"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useErrorModal = exports.QRCodeComponent = exports.useModalQrCode = exports.useToast = exports.ToastProvider = exports.useModalFormFullScreen = exports.ModalResolver = exports.useDownload = exports.useContract = exports.usePolicy = exports.useAlert = exports.useConfirm = exports.useModalWithRegister = exports.useKeyboardShortcuts = void 0;
const react_1 = __importStar(require("react"));
const react_hooks_async_modal_1 = require("react-hooks-async-modal");
const Button_1 = __importDefault(require("react-bootstrap/Button"));
const Modal_1 = __importDefault(require("react-bootstrap/Modal"));
require("./styles/modal.scss");
const localeSelector_1 = require("./localeSelector");
const hooks_1 = require("common/hooks");
const qrcode_1 = __importDefault(require("qrcode"));
const domain_1 = require("utils/domain");
const log_1 = require("common/log");
const error_boundary_1 = require("common/error-boundary");
// Helper hook for handling keyboard shortcuts in modals
const useKeyboardShortcuts = (onEnter, onEscape, enabled = true) => {
    const handleKeyDown = (0, react_1.useCallback)((event) => {
        if (event.key === "Enter" && onEnter) {
            onEnter();
        }
        else if (event.key === "Escape" && onEscape) {
            onEscape();
        }
    }, [onEnter, onEscape]);
    (0, react_1.useEffect)(() => {
        if (enabled) {
            document.addEventListener("keydown", handleKeyDown);
            return () => {
                document.removeEventListener("keydown", handleKeyDown);
            };
        }
    }, [enabled, handleKeyDown]);
};
exports.useKeyboardShortcuts = useKeyboardShortcuts;
const useModalWithRegister = (ModalComponent) => {
    const callCancelableModal = (0, react_hooks_async_modal_1.useCancellableModal)(ModalComponent);
    return (props) => {
        const [promise, canceller] = callCancelableModal(props);
        hooks_1.modalCancelEvent.on(canceller);
        return (() => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const response = yield promise;
                return response;
            }
            finally {
                hooks_1.modalCancelEvent.off(canceller);
            }
        }))();
    };
};
exports.useModalWithRegister = useModalWithRegister;
const confirm = ({ onResolve, message, closeOnEnter = true, }) => {
    (0, exports.useKeyboardShortcuts)(closeOnEnter ? () => onResolve(true) : undefined, () => onResolve(false));
    return (react_1.default.createElement(Modal_1.default, { show: true, onHide: () => onResolve(false) },
        react_1.default.createElement(Modal_1.default.Header, { closeButton: true },
            react_1.default.createElement(Modal_1.default.Title, null, "\u78BA\u8A8D")),
        react_1.default.createElement(Modal_1.default.Body, null,
            react_1.default.createElement("p", null, message)),
        react_1.default.createElement(Modal_1.default.Footer, null,
            react_1.default.createElement(Button_1.default, { variant: "secondary", onClick: () => onResolve(false) }, "\u30AD\u30E3\u30F3\u30BB\u30EB"),
            react_1.default.createElement(Button_1.default, { variant: "primary", onClick: () => onResolve(true) }, "OK"))));
};
const useConfirm = (params) => {
    return (0, exports.useModalWithRegister)((props) => confirm(Object.assign(Object.assign({}, props), { closeOnEnter: params === null || params === void 0 ? void 0 : params.closeOnEnter })));
};
exports.useConfirm = useConfirm;
const alert = ({ onResolve, message, }) => {
    (0, exports.useKeyboardShortcuts)(() => onResolve(), () => onResolve());
    return (react_1.default.createElement(Modal_1.default, { show: true, onHide: () => onResolve() },
        react_1.default.createElement(Modal_1.default.Header, { closeButton: true },
            react_1.default.createElement(Modal_1.default.Title, null, "\u78BA\u8A8D")),
        react_1.default.createElement(Modal_1.default.Body, null,
            react_1.default.createElement("p", null, message)),
        react_1.default.createElement(Modal_1.default.Footer, null,
            react_1.default.createElement(Button_1.default, { variant: "primary", onClick: () => onResolve() }, "OK"))));
};
const useAlert = () => {
    return (0, exports.useModalWithRegister)(alert);
};
exports.useAlert = useAlert;
const policy = ({ onResolve, message, availableLocales, }) => {
    (0, exports.useKeyboardShortcuts)(() => onResolve(), () => onResolve());
    const { formatMessage, formatString } = (0, hooks_1.useFormatter)();
    return (react_1.default.createElement(Modal_1.default, { show: true, className: "policy" },
        react_1.default.createElement(Modal_1.default.Header, null,
            react_1.default.createElement(Modal_1.default.Title, null,
                formatMessage("PrivacyPolicy.Title"),
                react_1.default.createElement("p", { style: { fontSize: "0.7em" } }, formatMessage("PrivacyPolicy.Text")),
                react_1.default.createElement("div", { style: { fontSize: "0.7em" } },
                    react_1.default.createElement(localeSelector_1.ConsumerLocaleSelector, { locales: availableLocales || [] })))),
        react_1.default.createElement(Modal_1.default.Body, { style: { overflow: "auto", height: "70vh" } },
            react_1.default.createElement("p", { style: { whiteSpace: "pre-wrap" } }, formatString(message)),
            react_1.default.createElement(Button_1.default, { variant: "primary", onClick: () => onResolve() }, "OK"))));
};
const usePolicy = () => {
    return (0, exports.useModalWithRegister)(policy);
};
exports.usePolicy = usePolicy;
const contract = ({ title, notice, message, buttonLabelOK, buttonLabelCancel, onResolve, }) => {
    (0, exports.useKeyboardShortcuts)(() => onResolve(true), () => onResolve(false));
    const { formatMessage, formatString } = (0, hooks_1.useFormatter)();
    return (react_1.default.createElement(Modal_1.default, { show: true, className: "policy" },
        react_1.default.createElement(Modal_1.default.Header, null,
            react_1.default.createElement(Modal_1.default.Title, null,
                react_1.default.createElement(react_1.default.Fragment, null,
                    formatString(title),
                    react_1.default.createElement("p", { style: { fontSize: "0.7em" } }, notice)))),
        react_1.default.createElement(Modal_1.default.Body, { style: { overflow: "auto", height: "70vh" } },
            react_1.default.createElement("p", { style: { whiteSpace: "pre-wrap" } }, formatString(message)),
            react_1.default.createElement("div", { style: {
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "20px",
                } },
                react_1.default.createElement(Button_1.default, { variant: "light", onClick: () => onResolve(false), style: { border: "1px solid #ccc" } }, buttonLabelCancel),
                react_1.default.createElement(Button_1.default, { variant: "primary", onClick: () => onResolve(true) }, buttonLabelOK)))));
};
const useContract = () => {
    return (0, exports.useModalWithRegister)(contract);
};
exports.useContract = useContract;
const download = ({ onResolve, message, url, filename, }) => {
    (0, exports.useKeyboardShortcuts)(() => onResolve(true), () => onResolve(false));
    return (react_1.default.createElement(Modal_1.default, { show: true, onHide: () => onResolve(false) },
        react_1.default.createElement(Modal_1.default.Header, { closeButton: true },
            react_1.default.createElement(Modal_1.default.Title, null, "\u78BA\u8A8D")),
        react_1.default.createElement(Modal_1.default.Body, null,
            react_1.default.createElement("p", null, message)),
        react_1.default.createElement(Modal_1.default.Footer, null,
            react_1.default.createElement(Button_1.default, { variant: "secondary", onClick: () => onResolve(false) }, "\u30AD\u30E3\u30F3\u30BB\u30EB"),
            react_1.default.createElement("a", { className: "btn btn-primary", href: url, onClick: (e) => onResolve(true), download: filename }, "OK"))));
};
const useDownload = () => {
    const dialog = (0, exports.useModalWithRegister)(download);
    return (params) => __awaiter(void 0, void 0, void 0, function* () {
        const blob = (() => {
            if ("blob" in params) {
                return params.blob;
            }
            else {
                return new Blob(params.data, { type: params.mimeType });
            }
        })();
        const url = URL.createObjectURL(blob);
        const filename = params.filename;
        yield dialog({ message: "ダウンロード", url, filename });
        setTimeout(() => {
            URL.revokeObjectURL(url);
        }, 1000);
    });
};
exports.useDownload = useDownload;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ModelResolverContext = react_1.default.createContext({
    onReject: () => { },
    onResolve: () => { },
});
const ModalResolver = ({ Component, }) => {
    const WrappedComponent = () => {
        const props = react_1.default.useContext(ModelResolverContext);
        return react_1.default.createElement(Component, Object.assign({}, props));
    };
    return react_1.default.createElement(WrappedComponent, null);
};
exports.ModalResolver = ModalResolver;
const modalFormFullScreen = ({ onResolve, onReject, title, children, }) => {
    (0, exports.useKeyboardShortcuts)(() => onResolve(undefined), () => onResolve(undefined));
    return (react_1.default.createElement(Modal_1.default, { show: true, className: "policy", onHide: () => onResolve(undefined), dialogClassName: "fullscreen-modal" },
        react_1.default.createElement(Modal_1.default.Header, { closeButton: true }, typeof title === "string" && react_1.default.createElement(Modal_1.default.Title, null, title)),
        react_1.default.createElement(ModelResolverContext.Provider, { value: { onResolve, onReject } },
            react_1.default.createElement(Modal_1.default.Body, { style: { overflow: "auto", height: "70vh" } }, children))));
};
const useModalFormFullScreen = () => {
    return (0, exports.useModalWithRegister)(modalFormFullScreen);
};
exports.useModalFormFullScreen = useModalFormFullScreen;
const ToastContext = react_1.default.createContext(null);
const Toast = ({ message, duration, onClose, type = "error", }) => {
    (0, react_1.useEffect)(() => {
        const timer = setTimeout(onClose, duration);
        return () => clearTimeout(timer);
    }, [duration, onClose]);
    return (react_1.default.createElement("div", { style: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            background: type === "success" ? "#28a745cc" : "#fccc",
            zIndex: 1000,
            textAlign: "center",
            padding: "0.1rem",
        } }, message));
};
const ToastProvider = ({ children }) => {
    const [toast, setToast] = (0, react_1.useState)(null);
    const closeToast = (0, react_1.useCallback)(() => {
        setToast(null);
    }, []);
    (0, react_1.useEffect)(() => {
        if (toast) {
            const timer = setTimeout(closeToast, toast.duration);
            return () => clearTimeout(timer);
        }
    }, [toast, closeToast]);
    const showToast = (0, react_1.useCallback)((params) => {
        setToast(params);
    }, []);
    return (react_1.default.createElement(ToastContext.Provider, { value: { showToast } },
        children,
        toast && (react_1.default.createElement(Toast, { message: toast.message, duration: toast.duration, type: toast.type, onClose: closeToast }))));
};
exports.ToastProvider = ToastProvider;
const useToast = () => {
    const context = react_1.default.useContext(ToastContext);
    if (!context) {
        throw new Error("useToast must be used within a ToastProvider");
    }
    return context.showToast;
};
exports.useToast = useToast;
const modalQrCode = ({ onResolve, value, }) => {
    (0, exports.useKeyboardShortcuts)(() => onResolve(undefined), () => onResolve(undefined));
    const url = value && new URL(value);
    const [additionalSearchParams, setAdditionalSearchParams] = (0, hooks_1.useLocalStorage)("qrCodeAdditionalSearchParams", "");
    const mergedSearchParams = new URLSearchParams(Object.fromEntries(new Map([
        ...new URLSearchParams(url.searchParams).entries(),
        ...new URLSearchParams(additionalSearchParams).entries(),
    ]))).toString();
    const mergedUrl = url &&
        new URL(`${url.origin}${url.pathname}${mergedSearchParams ? "?" + mergedSearchParams : ""}`).toString();
    return (react_1.default.createElement(Modal_1.default, { show: true, className: "policy", onHide: () => onResolve(undefined) },
        react_1.default.createElement(Modal_1.default.Header, { closeButton: true },
            react_1.default.createElement(Modal_1.default.Title, null, "QR Code")),
        react_1.default.createElement(Modal_1.default.Body, { style: { overflow: "auto", height: "70vh" } },
            react_1.default.createElement("div", null,
                react_1.default.createElement("input", { type: "text", value: additionalSearchParams, onChange: (e) => setAdditionalSearchParams(e.target.value) })),
            react_1.default.createElement("div", null,
                react_1.default.createElement(exports.QRCodeComponent, { value: mergedUrl })),
            react_1.default.createElement("div", null,
                react_1.default.createElement("a", { style: { wordBreak: "break-all" }, href: mergedUrl, target: "_blank", rel: "noreferrer" }, mergedUrl)))));
};
const useModalQrCode = () => {
    return (0, exports.useModalWithRegister)(modalQrCode);
};
exports.useModalQrCode = useModalQrCode;
const QRCodeComponent = ({ value }) => {
    const canvasRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (canvasRef.current) {
            const canvas = canvasRef.current;
            qrcode_1.default.toCanvas(canvas, value);
            if (domain_1.stagingAlertName) {
                const ctx = canvas.getContext("2d");
                if (!ctx)
                    return;
                // キャンバスの大きさを取得
                const canvasWidth = canvas.width;
                const canvasHeight = canvas.height;
                const text = "Sample";
                const fontSize = 20; // 例: 30px
                ctx.font = `${fontSize}px Arial`;
                ctx.fillStyle = "black";
                // テキストの幅と高さを取得
                const textMetrics = ctx.measureText(text);
                const textWidth = textMetrics.width;
                const textHeight = fontSize; // フォントサイズを直接利用
                const rectWidth = textWidth * 1.2;
                const rectHeight = textHeight * 1.2;
                // 矩形の開始位置を計算
                const rectX = (canvasWidth - rectWidth) / 2;
                const rectY = (canvasHeight - rectHeight) / 2;
                // 矩形を描画
                ctx.fillStyle = "white";
                ctx.fillRect(rectX, rectY, rectWidth, rectHeight);
                // テキストの開始位置を計算
                const startX = (canvasWidth - textWidth) / 2;
                const startY = (canvasHeight - textHeight) / 2 + textHeight * 0.8; // ベースラインの調整のため0.8を乗算
                // テキストを描画
                ctx.fillStyle = "black";
                ctx.fillText(text, startX, startY);
            }
        }
    }, [value]);
    return react_1.default.createElement("canvas", { ref: canvasRef });
};
exports.QRCodeComponent = QRCodeComponent;
const errorModal = ({ onResolve, error, internalMessage, userMessage, }) => {
    (0, exports.useKeyboardShortcuts)(() => onResolve(), () => onResolve());
    const errorInfo = (0, react_1.useMemo)(() => {
        return (0, log_1.errorLog)(error, { internalMessage, userMessage });
    }, [error]);
    return (react_1.default.createElement(Modal_1.default, { show: true, onHide: () => onResolve() },
        react_1.default.createElement(Modal_1.default.Header, { closeButton: true },
            react_1.default.createElement(Modal_1.default.Title, null, "\u30A8\u30E9\u30FC")),
        react_1.default.createElement(Modal_1.default.Body, { style: { padding: "0" } },
            react_1.default.createElement(error_boundary_1.DisplayError, { errorInfo: errorInfo })),
        react_1.default.createElement(Modal_1.default.Footer, null,
            react_1.default.createElement(Button_1.default, { variant: "primary", onClick: () => onResolve() }, "OK"))));
};
const useErrorModal = () => {
    return (0, exports.useModalWithRegister)(errorModal);
};
exports.useErrorModal = useErrorModal;
